import { render, staticRenderFns } from "./AccountBalanceMoneyEl.vue?vue&type=template&id=05c67c01&scoped=true&"
import script from "./AccountBalanceMoneyEl.vue?vue&type=script&lang=ts&"
export * from "./AccountBalanceMoneyEl.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalanceMoneyEl.vue?vue&type=style&index=0&id=05c67c01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c67c01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
